// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"b6acd89c","57":"ba857b03","124":"78dba4e2","353":"1699e9df","449":"49c07819","453":"c60c8afa","660":"0a3efde7","697":"c77c8484","712":"d860f434","935":"c5791941"}[chunkId] + ".chunk.js";
};